<div *ngIf="isLoading" class="loader">
  <mat-spinner></mat-spinner>
</div>

<div *ngIf="!isLoading" class="content">
  <router-outlet></router-outlet>
</div>
<notifier-container></notifier-container>
